import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CoApplicantRentVehicleComponent } from './co-applicant-rent-vehicle.component';
import { CoApplicantRentVehicleRoutingModule } from './co-applicant-rent-vehicle-routing.module';
import { RentVehicleGroupModule } from 'src/app/components/form-groups/rent-vehicle-group/rent-vehicle-group.module';
import { ValidationTextModule } from 'src/app/components/validation-text/validation-text.module';

@NgModule({
  declarations: [CoApplicantRentVehicleComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CoApplicantRentVehicleRoutingModule,
    RentVehicleGroupModule,
    ValidationTextModule,
  ],
  exports: [CoApplicantRentVehicleComponent],
})
export class CoApplicantRentVehicleModule {}
